import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { IoSearch } from "react-icons/io5";
import { TiArrowSortedUp, TiArrowSortedDown } from "react-icons/ti";
import { Table, Pagination } from "react-bootstrap";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import sort from "../../assets/sort.svg";
import filter from "../../assets/filter.svg";
import ToastMsg from "../../component/comman/ToastMsg";
import { dashboardList, deleteTransaction } from "../../services/ApiServices";
import $ from 'jquery';
import 'bootstrap-daterangepicker/daterangepicker.css';
import 'bootstrap-daterangepicker';
import moment from 'moment';
import pdf from "../../assets/pdf.svg";
import { downloadBase64Pdf } from "../../auth/utils/Utils";
import { GoEyeClosed } from "react-icons/go";


function Reports() {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [customers, setCustomers] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [summary, setSummary] = useState([]);
  const [order, setOrder] = useState("-transaction_date");
  const [transactionType, setTransactionType] = useState("");
  const [allTransactions, setAllTransactions] = useState(false);
  const [isPdf, setIsPdf] = useState(false);
  const [hideOne, setHideOne] = useState(() => {
    const storedValue = localStorage.getItem('hideFour');
    return storedValue === 'true' ? true : false;
  });
  const [hideTwo, setHideTwo] = useState(() => {
    const storedValue = localStorage.getItem('hideFive');
    return storedValue === 'true' ? true : false;
  });
  const [hideThree, setHideThree] = useState(() => {
    const storedValue = localStorage.getItem('hidesix');
    return storedValue === 'true' ? true : false;
  });
  const [pageInfo, setPageInfo] = useState({
    current_page: 1,
    total_pages: 1,
    has_next: false,
    has_previous: false,
  });
  const getCustomersDetails = useCallback(
    (params = {}) => {
      const queryParams = { ...params, page_num: currentPage, per_page_data: itemsPerPage, };
      dashboardList(queryParams)
        .then((res) => {
          console.log("API Response:", res.data);
          if (res.status === 200 && Array.isArray(res?.data?.data)) {
            setSummary(res?.data?.transaction_summary)
            setCustomers(res?.data?.data);
            setPageInfo(res?.data?.page_info);
            setTotalPages(res?.data?.page_info.total_pages);
            setFilteredCustomers(res?.data?.data);
            setCompanyName(res?.data?.entity_name)

          } else {
            let file_name = `${companyName}.pdf`
            console.log(file_name)
            downloadBase64Pdf(res?.data?.pdf_base64, file_name);
            // setCustomers([]);
            // setFilteredCustomers([]);
          }
        })
        .catch((err) => {
          console.error("API Error:", err);
          if (err.response?.status === 401) {
            navigate("/");
          }
          let error = err?.response?.data?.error || "something went wrong";
          ToastMsg(error, "error");
          // setCustomers([]);
          // setFilteredCustomers([]);
        });
    },
    [navigate, currentPage, itemsPerPage]
  );

  const handleDateRangeChange = (start, end) => {
    const startDate = start.format('YYYY-MM-DD');
    const endDate = end.format('YYYY-MM-DD');
    getCustomersDetails({ start_date: startDate, end_date: endDate, all_transactions: false, page_type: "report", order: order, transaction_type: transactionType, isPdf: isPdf });
  };

  useEffect(() => {
    // Initialize the daterangepicker
    $('input[name="daterange"]').daterangepicker(
      {
        opens: 'left',
        startDate: moment(),
        endDate: moment(),
        maxDate: moment(),
        locale: {
          format: 'DD/MM/YYYY',
        },
        ranges: {
          'Today': [moment(), moment()],
          'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          'Last 30 Days': [moment().subtract(29, 'days'), moment()],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
          'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        },
      },
      handleDateRangeChange
    );

    return () => {
      $('input[name="daterange"]').daterangepicker('destroy');
    };
  }, []); 

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const dateRange = $('input[name="daterange"]').data('daterangepicker');
      const startDate = dateRange.startDate.format('YYYY-MM-DD');
      const endDate = dateRange.endDate.format('YYYY-MM-DD');
      getCustomersDetails({ start_date: startDate, end_date: endDate, filter_value: searchTerm, all_transactions: allTransactions, page_type: "report", order: order, transaction_type: transactionType, isPdf: isPdf });
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm, allTransactions, getCustomersDetails]);

  useEffect(() => {
    setFilteredCustomers(customers);
    setTotalPages(Math.ceil(customers.length / itemsPerPage));
  }, [customers, itemsPerPage]);

  const handleSort = (sortOrder) => {
    const params = { order: sortOrder };
    const dateRange = $('input[name="daterange"]').data('daterangepicker');
    const startDate = dateRange.startDate.format('YYYY-MM-DD');
    const endDate = dateRange.endDate.format('YYYY-MM-DD');
    setOrder(sortOrder)
    getCustomersDetails({ start_date: startDate, end_date: endDate, filter_value: searchTerm, all_transactions: allTransactions, page_type: "report", order: sortOrder, transaction_type: transactionType, isPdf: isPdf });
  };

  const handleAccounts = (sortOrder) => {
    const params = { transaction_type: sortOrder };
    const dateRange = $('input[name="daterange"]').data('daterangepicker');
    const startDate = dateRange.startDate.format('YYYY-MM-DD');
    const endDate = dateRange.endDate.format('YYYY-MM-DD');
    setTransactionType(sortOrder)
    // getCustomersDetails(params);
    getCustomersDetails({ start_date: startDate, end_date: endDate, filter_value: searchTerm, all_transactions: allTransactions, page_type: "report", order: order, transaction_type: sortOrder, isPdf: isPdf });

  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleCloseButtonClick = () => {
    const dateRange = $('input[name="daterange"]').data('daterangepicker');
    const startDate = dateRange.startDate.format('YYYY-MM-DD');
    const endDate = dateRange.endDate.format('YYYY-MM-DD');

    deleteTransaction({ start_date: startDate, end_date: endDate })
      .then((res) => {
        if (res.status === 200) {
          ToastMsg("Transactions closed successfully", "success");
          getCustomersDetails({ start_date: startDate, end_date: endDate, page_type: "report" });
        } else {
          ToastMsg("Failed to closed transactions", "error");
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        ToastMsg("Something went wrong", "error");
      });
  };

  const handleExport = (value) => {
    const dateRange = $('input[name="daterange"]').data('daterangepicker');
    const startDate = dateRange.startDate.format('YYYY-MM-DD');
    const endDate = dateRange.endDate.format('YYYY-MM-DD');
    setIsPdf(true);
    getCustomersDetails({ start_date: startDate, end_date: endDate, all_transactions: allTransactions, page_type: "report", order: order, transaction_type: transactionType, is_pdf: true });
  }

  return (
    <>
      <div className="dasboard-content">
        <div className="card mb-4">
          <div className="card-body">
            <div className="search-sc d-flex align-items-center justify-content-between">
              <form className="d-flex align-items-center">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <IoSearch className="search-icon" />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    name="daterange"
                    className="form-control date-range"
                    placeholder="All Time"
                  />
                </div>
                <div className="checkbox flex nowrap align-center" style={{ marginLeft: "10px" }}>
                  <lable className="label-tran">All <span>Transactions</span></lable>
                  <input
                    type="checkbox"
                    style={{ marginLeft: "10px" }}
                    checked={allTransactions}
                    onChange={(e) => setAllTransactions(e.target.checked)}
                  />
                </div>
              </form>
            </div>
            <div className="cr-dr">
              <div className="row">
                <div className="colm green">
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="d-flex align-items-center">
                      Debit <TiArrowSortedDown />
                    </p>
                    <GoEyeClosed onClick={() => {
                      setHideOne((hideOne) => {
                        const newValue = !hideOne;
                        localStorage.setItem('hideFour', newValue.toString());
                        return newValue;
                      });
                    }} />
                  </div>
                  <h2 className={hideOne ? "active" : ""}>€ {summary?.total_debit || 0}</h2>
                </div>
                <div className="colm red">
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="d-flex align-items-center">
                      Credit <TiArrowSortedUp />
                    </p>
                    <GoEyeClosed onClick={() => {
                      setHideTwo((hideTwo) => {
                        const newValue = !hideTwo;
                        localStorage.setItem('hideFive', newValue.toString());
                        return newValue;
                      });
                    }} />
                  </div>
                  <h2 className={hideTwo ? "active" : ""}>€ {summary?.total_credit || 0}</h2>
                </div>
                <div className="colm blue">
                  <div className="d-flex align-items-center justify-content-between">
                    <p>Balance</p>
                    <GoEyeClosed onClick={() => {
                      setHideThree((hideThree) => {
                        const newValue = !hideThree;
                        localStorage.setItem('hidesix', newValue.toString());
                        return newValue;
                      });
                    }} />
                  </div>
                  <h2 className={hideThree ? "active" : ""}>€ {summary?.net_transaction || 0}</h2>
                </div>
                <div className="colm button-dv">
                  <button className="btn" onClick={handleCloseButtonClick}>Close</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card mb-4">
          <div className="card-body">
            <div className="card-header d-flex align-items-center justify-content-between">
              <h5>All Transactions</h5>
              <div className="filter d-flex align-items-center">
                <div className="link d-flex align-items-center cusr-ptr" onClick={() => handleExport(true)}>
                  <img src={pdf} alt="icon" width={24} height={21} />
                  <span>Export PDF</span>
                </div>
                <div className="dropdown">
                  <button className="flex align-items-center">
                    <span>Sort</span>
                    <img src={sort} alt="icon" width={18} height={15} />
                  </button>
                  <div className="subMenu">
                    <ul>
                      <li onClick={() => handleSort("customer__name")}>Name <TiArrowSortedDown /></li>
                      <li onClick={() => handleSort("-customer__name")}>Name <TiArrowSortedUp /></li>
                      <li onClick={() => handleSort("transaction_date")}>Date <TiArrowSortedDown /></li>
                      <li onClick={() => handleSort("-transaction_date")}>Date <TiArrowSortedUp /></li>
                      <li onClick={() => handleSort("balance")}>Balance <TiArrowSortedDown /></li>
                      <li onClick={() => handleSort("-balance")}>Balance <TiArrowSortedUp /></li>
                    </ul>
                  </div>
                </div>
                <div className="dropdown" style={{ marginLeft: "10px" }}>
                  <button className="flex align-items-center">
                    <span>Filter</span>
                    <img src={filter} alt="icon" width={18} height={15} />
                  </button>
                  <div className="subMenu">
                    <ul>
                      <li onClick={() => handleAccounts("")}>All</li>
                      <li onClick={() => handleAccounts("credit")}>Credit</li>
                      <li onClick={() => handleAccounts("debit")}>Debit</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive report">
              <Table className="dashboard table-centered table-striped table-hover mb-0">
                <thead className="table-light">
                  <tr>
                    <th style={{ cursor: "pointer" }}>Date</th>
                    <th style={{ cursor: "pointer" }}>Customer</th>
                    <th style={{ cursor: "pointer" }}>Details</th>
                    <th style={{ cursor: "pointer" }}>Debit & Credit</th>
                    <th style={{ cursor: "pointer" }}>Balance</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCustomers.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No Data Found
                      </td>
                    </tr>
                  ) : (
                    filteredCustomers.map((user, index) => (
                      <tr key={index}>
                        <td>{moment(user.transaction_date).format('DD/MM/YYYY')}</td>
                        <td>{user.customer__name}</td>
                        <td className="detail-td">{user.details}</td>
                        <td className={user.transaction_type === 'debit' ? "green" : "red"}>
                          €{" "}{user.transaction_amount}{user.transaction_type === 'debit' ? <TiArrowSortedDown /> : <TiArrowSortedUp />}
                        </td>
                        <td>€{" "}{user.balance || "00.00"}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
            <div className="d-flex justify-content-between align-items-center border-top pagination-wrapper">
              <div className="text-muted small">
                {(currentPage - 1) * itemsPerPage + 1}-
                {10 * (currentPage - 1) + filteredCustomers.length}
                {" "}of {pageInfo.total_data || "0"}
              </div>
              <div className="d-flex align-items-center">
                <div className="form-group d-flex align-items-center">
                  <label htmlFor="itemsPerPage">Rows per page:</label>
                  <select
                    id="itemsPerPage"
                    className="form-control"
                    value={itemsPerPage}
                    onChange={(e) => setItemsPerPage(Number(e.target.value))}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                  <MdOutlineKeyboardArrowDown />
                </div>
                <Pagination size="sm" className="pagination-rounded mb-0">
                  <Pagination.Prev
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  />
                  <p>
                    <span>{currentPage}</span>/{pageInfo.total_pages}
                  </p>
                  <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === pageInfo.total_pages}
                  />
                </Pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Reports;

